import * as React from 'react';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './CompilationItem.css';

export interface ICompilationItemProps {
  description: string;
  icon: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
  title: string;
  url: string;
}

export const CompilationItem: React.FC<ICompilationItemProps> = ({ description, icon, title, url, onClick }) => {
  return (
    <a
      className={styles['compilation']}
      href={url}
      title={title}
      onClick={onClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={styles['icon']} style={{ backgroundImage: `url('${icon}')` }} />
      <div className={styles['content']}>
        <div className={styles['title']}>
          <ArticleHeading4 as="h3">
            <span className={styles['no-wrap']}>{title}</span>
          </ArticleHeading4>
        </div>

        <ArticleParagraph1 color="text-primary-disabled">
          <span className={styles['no-wrap']}>{description}</span>
        </ArticleParagraph1>
      </div>
      <div className={styles['arrow']}>
        <IconActionChevronRight16 color="icon-secondary-default" />
      </div>
    </a>
  );
};
